export const mapDEPBRequest = (formData) => {

  return{
    exportProductDEPBProductgroup: formData.exportProductDEPBProductgroupMain,
    exportProductRateList:formData.exportProductRateListMain,
    exportProductStdIONorms:formData.exportProductStdIONormsMain,
    exportProductDEPBRate:formData.exportProductDEPBRateMain,
    exportProductDEPBQty:formData.exportProductDEPBQtyMain,
    exportProductDEPBUnit:formData.exportProductDEPBUnitMain,
    exportProductCapValue:formData.exportProductCapValueMain
  }
}


export const mapDEPBResponse = (res) =>{
    return{
        exportProductId:res.exportProductId,
        depbId: res.exportProductDEPBId,
        exportProductDEPBProductgroupMain : res.exportProductDEPBProductgroup,
        exportProductRateListMain : res.exportProductRateList,
        exportProductStdIONormsMain : res.exportProductStdIONorms,
        exportProductDEPBRateMain : res.exportProductDEPBRate,
        exportProductDEPBQtyMain : res.exportProductDEPBQty,
        exportProductDEPBUnitMain : res.exportProductDEPBUnit,
        exportProductCapValueMain : res.exportProductCapValue
    }
}